<template>
  <div class="nav-wrapper">
    <q-layout-header id="navigation">
      <q-toolbar class="navigation" color="brand">
        <router-link class="logo" :to="{ name: 'dashboard' }">
          <logo />
        </router-link>
        <div v-if="compressed" class="navigation--compressed">
          <div class="navigation-subtitle">
            <router-link :to="compressedSubtitle.link">Back</router-link>
          </div>
          <h3 class="navigation-title no-margin">{{ compressedTitle }}</h3>
          <div class="right-align">
            <div
              v-if="compressedUnpublishedChanges > 0"
              class="unpublished-changes"
            >
              {{ $t("ui.drag_editor.unpublished_changes") }}
            </div>
            <add-button />
          </div>
        </div>
        <div v-else>
          <q-tabs color="brand">
            <!-- Main navigation -->
            <q-route-tab
              v-for="routes in mainNavigation"
              exact
              slot="title"
              :is="
                Array.isArray(routes.submenu)
                  ? 'q-route-tab'
                  : 'authenticated-navigation-item'
              "
              :key="routes.label"
              :bindings="getBindings(routes)"
              :to="Array.isArray(routes.submenu) ? `` : ''"
              v-can="routes.credential"
              v-if="allowedInPlan(routes.label)"
              :auth="routes.auth"
              :label="
                Array.isArray(routes.submenu)
                  ? $t('ui.menu.' + routes.label)
                  : routes.label
              "
              :class="Array.isArray(routes.submenu) ? 'submenu' : ''"
              v-on:click.native="onClick(routes)"
            >
              <q-popover
                v-if="Array.isArray(routes.submenu)"
                fit
                class="navigation-dropdown"
              >
                <q-tabs align="center" class="dropdown" color="brand">
                  <q-route-tab
                    is="authenticated-navigation-item"
                    exact
                    slot="title"
                    :hidden="subroutes.disabled"
                    v-for="subroutes in routes.submenu"
                    :key="subroutes.label"
                    v-can="subroutes.credential"
                    v-if="allowedInPlan(subroutes.label)"
                    :bindings="getBindings(subroutes)"
                    :auth="subroutes.auth"
                    :label="subroutes.label"
                    v-on:click="onClick(subroutes)"
                    @close="close()"
                  />
                </q-tabs>
              </q-popover>
            </q-route-tab>

            <!-- Content Manager Dropdown -->
            <q-route-tab :to="``" exact slot="title" class="submenu">
              {{ $t("ui.menu.content_manager") }}
              <q-popover fit class="navigation-dropdown" ref="contentManager">
                <q-tabs align="center" class="dropdown" color="brand">
                  <q-route-tab
                    is="authenticated-navigation-item"
                    exact
                    slot="title"
                    v-for="routes in contentManager"
                    :key="routes.label"
                    v-can="routes.credential"
                    v-if="allowedInPlan(routes.label)"
                    :bindings="getBindings(routes)"
                    :auth="routes.auth"
                    :label="routes.label"
                    v-on:click.native="onClick()"
                    @close="close()"
                  />
                  <div class="menu-title-tab">Engagement</div>
                  <a :href="businessKitLink" target="_blank">
                    <q-tab class="content-start businesskit-tab">
                      <span>{{ $t("ui.menu.businesskits") }}</span>
                      <img src="../../../assets/bk.svg" alt />
                    </q-tab>
                  </a>
                </q-tabs>
              </q-popover>
            </q-route-tab>
            <!-- <q-route-tab
              is="authenticated-navigation-item"
              exact
              slot="title"
              v-for="routes in mainNavigationUser"
              :key="routes.label"
              v-can="routes.credential"
              :bindings="getBindings(routes)"
              :auth="routes.auth"
              :label="routes.label"
              v-on:click.native="onClick()"
            />-->
            <!-- Account dopdown -->
            <q-route-tab :to="``" exact slot="title" class="submenu account">
              <user-image
                :firstname="currentUser.firstname"
                :lastname="currentUser.lastname"
                :email="currentUser.email == 'unknown' ? '' : currentUser.email"
                theme="sensual"
              />
              <q-popover
                fit
                class="navigation-dropdown account-overlay dropdown"
                ref="account"
              >
                <language-switcher />

                <q-tabs
                  align="center"
                  class="dropdown"
                  color="brand"
                  v-if="userId"
                >
                  <q-route-tab
                    is="authenticated-navigation-item"
                    exact
                    slot="title"
                    v-for="routes in account"
                    :key="routes.label"
                    v-can="routes.credential"
                    v-if="allowedInPlan(routes.label)"
                    :bindings="getBindings(routes)"
                    :auth="routes.auth"
                    :label="routes.label"
                    @close="close()"
                  />
                </q-tabs>
              </q-popover>
            </q-route-tab>
          </q-tabs>
        </div>
      </q-toolbar>
    </q-layout-header>
  </div>
</template>
<script>
import Logo from "@/components/layouts/partials/Logo";
import LanguageSwitcher from "@/components/layouts/partials/LanguageSwitcher.vue";
import AuthenticatedNavigationItem from "@/components/layouts/partials/AuthenticatedNavigationItem";
import AddButton from "@/components/layouts/partials/AddButton.vue";
import UserImage from "@/components/helpers/Specific/UserImage";

export default {
  components: {
    Logo,
    LanguageSwitcher,
    AuthenticatedNavigationItem,
    AddButton,
    UserImage
  },
  computed: {
    currentUser: {
      get() {
        return this.$store.getters.currentUser;
      }
    },
    compressed() {
      return this.$store.getters.getHeaderState.compressed;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
    accountLabel() {
      if (this.currentUser.firstname || this.currentUser.lastname) {
        let label = "";
        if (this.currentUser.firstname) {
          label += `${this.currentUser.firstname} `;
        }
        if (this.currentUser.lastname) {
          label += this.currentUser.lastname;
        }
        return label;
      }
      return this.currentUser.email;
    },
    userId() {
      return this.$store.getters.currentUser.id;
    },
    businessKitLink() {
      return this.$store.getters.getBusinessKitLink;
    },
    compressedSubtitle() {
      return this.$store.getters.getSubtitle;
    },
    compressedUnpublishedChanges() {
      // Right now only works for DragNDropEditor but can be made to use anything
      return this.$store.getters.getDragEditorUnpublishedChanges;
    },
    compressedTitle() {
      let pageTitle = this.$store.state.page_title;
      if (pageTitle.params) {
        return this.$t(pageTitle.label, pageTitle.params);
      } else {
        return this.$t(pageTitle.label);
      }
    },
    account() {
      let menu = [
        {
          id: 7,
          label: "sync",
          credential: "projects.synchronize",
          auth: "allowed_crm",
          page: `/projects_synchronize`
        },
        {
          id: 8,
          label: "profile",
          credential: "users.me",
          page: {
            name: "user_profile",
            params: {
              id: this.userId
            }
          }
        },
        {
          id: 9,
          label: "logout",
          page: {
            name: "logout"
          }
        }
      ];
      return menu;
    }
  },
  data() {
    return {
      LanguageSwitcher,
      mainNavigation: [
        {
          label: "people",
          credential: "contact_manager.show",
          submenu: [
            {
              label: "contacts",
              page: {
                name: "contacts"
              },

              credential: "contacts.show",
              classes: ["dropdown--item"]
            },
            {
              label: "segments",
              page: {
                name: "segments"
              },
              credential: "segments.show",
              classes: ["dropdown--item"]
            },
            {
              label: "companies",
              page: {
                name: "companies"
              },
              credential: "companies.show",
              classes: ["dropdown--item"]
            }
          ]
        },
        {
          label: "projects",
          page: {
            name: "projects"
          },
          credential: "projects.list"
        }
      ],
      contentManager: [
        {
          label: "menu_tab_lead_capture",
          classes: ["menu-title-tab"],
          credential: "lead_masks.list"
        },
        {
          label: "lead_masks",
          page: {
            name: "lead_masks"
          },
          credential: "lead_masks.list",
          auth: "allowed_custom_leadsheets",
          classes: ["dropdown--item"]
        },
        {
          label: "external_forms",
          page: {
            name: "external_forms"
          },
          credential: "external_forms.list",
          auth: "allowed_forms",
          classes: ["dropdown--item"]
        },
        {
          label: "menu_tab_settings",
          classes: ["menu-title-tab"],
          credential: "lead_masks.list"
        },
        {
          label: "users",
          page: {
            name: "users"
          },
          credential: "users.list"
        },
        {
          label: "workflows",
          page: {
            name: "workflows"
          },
          credential: "workflows.list",
          //auth: "allowed_custom_leadsheets",
          classes: ["dropdown--item"]
        },
        {
          id: 3,
          label: "organizations",
          page: {
            name: "organizations"
          },
          credential: "organizations.list"
        },
        {
          id: 4,
          label: "plans",
          page: {
            name: "plans"
          },
          credential: "plans.list"
        }
      ],
      mainNavigationUser: [
        {
          id: 2,
          label: "users",
          page: {
            name: "users"
          },
          credential: "users.list"
        }
      ],
      accountDropdown: [
        {
          id: 9,
          label: "logout",
          page: {
            name: "logout"
          }
        }
      ],
      crmSyncButton: {
        id: 7,
        label: "sync",
        credential: "projects.synchronize",
        auth: "allowed_crm",
        page: `/projects_synchronize`
      }
    };
  },
  methods: {
    getBindings(item) {
      let bindings = {
        to: {},
        class: []
      };

      if (item.page) {
        bindings.to = item.page;
      }
      if (item.classes) {
        bindings.class = item.classes;
      }

      return bindings;
    },
    // Close the pop overs
    close() {
      Object.keys(this.$refs).forEach(key => {
        let ref = this.$refs[key];
        ref.hide();
      });
    },
    onClick(item = null) {
      if (item && (item.disabled === true || Array.isArray(item.submenu))) {
        return;
      }
      this.$store.commit("RESET_ALL_PAGES");
    },
    accountDropdownItems() {
      // add Sync Button if CRM is connected
      if (this.$store.getters.getOrganizationConfig("crm_presence")) {
        this.accountDropdown.unshift(this.crmSyncButton);
      }
      return this.accountDropdown;
    },
    allowedInPlan(label) {
      if (this.$store.getters.getCurrentOrganizationPlan) {
        let navigationRules = this.$store.getters.getCurrentOrganizationPlan.rules.exclude_from_navigation
        if (navigationRules) {
          return !navigationRules.includes(label)
        }
      }
      return true
    }
  }
};
</script>
<style lang="sass" scoped>

.menu-item-wrapper
  display: flex
  line-height: 18.4px

.q-tabs-head
  display: none

.q-tabs-bar
  border: 0

.q-tab
  text-transform: none
  font-weight: $font-medium
  font-size: .95em
  min-height: 70px
  padding: 0 30px 0 20px
  color: $ink-lighter
  cursor: pointer
  background: transparent
  transition: all .15s ease-out
  &:hover
    color: $paper-lighter
    &:before
      background: $ink-dark
  &:active
    color: $paper-lighter

.businesskit-tab
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: center !important
  img, span
    margin-top: 13px


.q-toolbar
  min-height: 70px
  padding-top: 0
  padding-bottom: 0

.account-overlay
  position: fixed
  right: 30px
  left: auto !important
  top: 70px
  min-width: 288px !important

.submenu
  background: transparent
  position: relative
  &:first-child
    background: transparent
  &.account
    position: absolute
    right: 30px
    &::after
      top: 30px
  &::after
    @extend .icon
    content: '\e930'
    vertical-align: text-bottom
    font-size: .8em
    padding-right: .8em
    position: absolute
    right: 0


.menu-title-tab
  min-height: 30px !important
  background-color: $paper-light !important
  font-size: 12px !important
  color: $ink !important
  display: flex
  align-items: center
  padding-left: 20px
  border-top: 1px solid $paper !important
  pointer-events: none
  font-weight: 400 !important

.no-highlight
  background: $ink-dark

#navigation
  box-shadow: none
  .bg-brand
    background: $ink-dark
  .q-btn
    box-shadow: none

.language-switcher
  z-index: 999999

.navigation-dropdown
  background: #ffffff
  box-shadow: 0 20px 66px 0 rgba(34,48,73,0.2)
  border-radius: 4px
  width: 219px
  max-height: 80vh !important
.dropdown--item
  text-align: left

.navigation--compressed
  position: relative
  display: flex
  align-items: center
  width: 95vw
  .right-align
    position: absolute
    right: 30px
    display: flex
    align-items: center
  .unpublished-changes
    margin-right: 20px
    font-size: 14px
    color: $paper
  .navigation-title
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    max-width: 55%
  @media(max-width: 1340px)
    .navigation-title
      max-width: 45%
  @media(max-width: 1120px)
    .navigation-title
      max-width: 35%
  @media(max-width: 970px)
    .navigation-title
      max-width: 25%
  .navigation-subtitle
    margin-right: 30px
    display: inline-block
    color: $ink-lighter
    font-size: 14px
    font-weight: $font-regular
    a
      color: inherit
      text-decoration: none
      display: inline-block
      transition: all .15s ease-out
      &:hover
        color: $paper
    &::before
      @extend .icon
      content: '\e909'
      vertical-align: sub
      font-size: 17px
      padding-right: .5em

.dropdown
  .q-tabs-pane
    display: flex

  .q-tab
    align-self: flex-start
    min-height: 60px
    text-transform: none
    font-weight: $font-medium
    font-size: .95em
    color: $ink-lighter
    transition: all .15s ease-out
    background: transparent
    width: 100%
    align-items: baseline
    border-top: 1px solid $paper
    &:last-child
      border-bottom: 0px solid $paper
    &:hover
      color: $ink-dark
      background: $paper-lighter !important
      &:before
        background: #fff
    &:active
      color: $ink-dark
    &::before
      background: $paper-light

.logo
  padding: 0em 2em
</style>



// WEBPACK FOOTER //
// Navigation.vue?f0ce70de